module.exports = __webpack_public_path__ + "img/SprungpunktIcon_bw.13391ffa.png";